<script>

import axios from "axios";
import {toast} from "vue3-toastify";
import modalKkMixin from "../conversation-club/modal-kk-mixin.js";


import {defineComponent} from 'vue'

export default defineComponent({
  mixins: [modalKkMixin],
  props:['semester', 'semesters'],

  data() {
    return {
      showM: false,
      semester: {name: '', start_date: '', end_date: '', id: null},
    }
  },
  name: "semester-form",
  methods: {

    removeSemester(s){
      if (confirm("Opravdu smazat semestr "+s.name+"?")){
        axios.delete(`/onlajnovka/semesters/${s.id}.json`).then(re=>{
          if (re.status===200){
            this.$emit('semester-updated')
            toast.success("Semestr smazán")
          }
        }).catch(e=>{
          toast.error("Chyba při mazání semestru: "+e.response.data.message)
        })
      }
    },


    async duplikovat(s) {

      const re = await axios.post(`/onlajnovka/semesters/copy/${s.id}.json`)
      if (re.status === 200) {

        this.$emit('semester-updated')
        toast.success("Semestr duplikován")
      }
    },



    async saveSemester() {
      try {
        if (this.semester.id) {
          await axios.put(`/onlajnovka/semesters/${this.semester.id}.json`, {semester: this.semester})
        } else {
          await axios.post('/onlajnovka/semesters.json', {semester: this.semester})
        }
        // this.hideModal()
        this.$emit('semester-updated')
        this.semester={id: null, name: '', start_date:'', end_date:''}
        toast.success("Semestr uložen")
      } catch (e) {
        toast.error("Chyba při ukládání semestru")
      }
    },
  }
})
</script>

<template>
<vue-final-modal v-model="showM" classes="modal-container " content-class="modal-content-f mcw1">

    <div class="modal-header">
      <span class="modal__title">Semestry
      </span>
      <button type="button" class="close" @click.prevent="hideModal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal__content">

      <div class="row">

        <div class="form-group col-md-6">
          <label for="name">Název</label>
          <input type="text" class="form-control" id="name" v-model="semester.name" placeholder="Název semestru">
        </div>

        <div class="form-group col-md-6">
          <label for="start_date">Datum začátku</label>
          <input type="date" class="form-control" id="start_date" v-model="semester.start_date" placeholder="Datum začátku">
        </div>

        <div class="col-md-12 text-right">
          <button type="button" class="btn btn-primary" @click.prevent="saveSemester">{{semester.id>0 ? "Uložit změny" : "Vytvořit" }}</button>
        </div>

      </div>


      <b>Semestry</b>
      <table class="table table-condensed">
        <thead>
          <tr>
            <th>ID</th>
            <th>Název</th>
            <th>Začátek</th>
            <th colspan="3" class="text-center">Akce</th>
          </tr>
        </thead>
        <tr v-for="s in semesters" :key="s.id">
          <td>{{s.id}}</td>
          <td>{{ s.name }}</td>
          <td>{{ s.start_date }}</td>
          <td><a class="cursor-pointer" href="#" @click.prevent="semester = {...s}; showM = true;">Upravit</a></td>
          <td><a class="cursor-pointer" href="#" @click.prevent="duplikovat(s)">Duplikovat</a></td>
          <td>

            <a  href="#" title="smazat" @click.prevent="removeSemester(s)"><span class="material-icons-outlined mazani">delete</span></a>

          </td>
        </tr>
      </table>


    </div>



</vue-final-modal>
</template>

<style scoped>

.mazani{
  color:red;
}
</style>